import { render } from "./MetricGroupOrder.vue?vue&type=template&id=ff3d0cdc"
import script from "./MetricGroupOrder.vue?vue&type=script&lang=js"
export * from "./MetricGroupOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__